import 'regenerator-runtime/runtime';

// node_modules
import 'promise-polyfill/src/polyfill';
import 'custom-event-polyfill';
import 'url-search-params-polyfill';
import 'string.prototype.startswith';

// vendored and custom polyfills
import '../lib/event_func_constructor_polyfill';
import '../lib/math_sign_polyfill';



// WEBPACK FOOTER //
// ./app/javascript/globals/polyfills.js